import {create} from 'zustand';
import { manageContent, editData, linkTag, allTag, cmsContent, getPng, cmsEditContent, imageUpload, allSegment, deleteContent, cmsContentTag, postTag, addContent} from '../api_layer/api';

export const useManageContentStore = create((set) => ({
    contentData: [],
    tagData:[],
    segData:[],
    cmsContentData:[],
    imageData:[],
    updateImageData:[],
    imageUploadResponse:[],
    contentTagData:[],
    contentLoading: false,
    tagLoading:false,
    segLoading:false,
    cmsContentLoading:false,
    imagePathLoading:false,
    cmsTagLoading:false,
    statusLoading:false,
    imageLoading:false,
    addContentLoading:false,
    error: null,
    fetchManageContentData: async (page,type, keyword) => {
      try {
        set({ contentLoading: true, error: null });
        const response = await manageContent(page,type, keyword);
        set({ contentData: response.data, contentLoading: false });
      } catch (error) {
        set({ error: error.message, contentLoading: false });
      }
    },
    fetchAllTagData: async () => {
      try {
        set({ tagLoading: true, error: null });
        const response = await allTag();
        set({ tagData: response.data, tagLoading: false });
      } catch (error) {
        set({ error: error.message, tagLoading: false });
      }
    },
    fetchAllSegData: async () => {
      try {
        set({ segLoading: true, error: null });
        const response = await allSegment();
        set({ segData: response.data, segLoading: false });
      } catch (error) {
        set({ error: error.message, segLoading: false });
      }
    },
    fetchCmsContentData: async (id) => {
      try {
        set({ cmsContentLoading: true, error: null });
        const response = await cmsContent(id);
        set({ cmsContentData: response.data, cmsContentLoading: false });
      } catch (error) {
        set({ error: error.message, cmsContentLoading: false });
      }
    },
    fetchCmsContentTagData: async (id) => {
      try {
        set({ cmsTagLoading: true, error: null });
        const response = await cmsContentTag(id);
        set({ contentTagData: response.data, cmsTagLoading: false });
      } catch (error) {
        set({ error: error.message, cmsTagLoading: false });
      }
    },
    fetchImageData: async (filePath) => {
      try {
        set({ imagePathLoading: true, error: null });
        const response = await getPng(filePath);
        set({ imageData: response.data, imagePathLoading: false });
      } catch (error) {
        set({ error: error.message, imagePathLoading: false });
      }
    },
    postImageUpload: async (payload, setImageUploading) => {
      try {
        set({ imageLoading: true, error: null });
        const response = await imageUpload(payload);
        set({ imageUploadResponse:response?.data, imageLoading: false });
        setImageUploading(false);
      } catch (error) {
        set({ error: error.message, imageLoading: false });
      }
    },
    updateImageContent: async (id, payload,setToaster, fetchManageContentData, filter, searchText , setModalShow) => {
      try {
        set({ statusLoading: true, error: null });
        const response = await cmsEditContent(id, payload);
        setToaster("Update Content", "Content saved successfully", "success");
        set({updateImageData:response.data, statusLoading: false });
        if (searchText) {
            const keyword = `&key=${searchText}&`;
            if (searchText && filter) {
              fetchManageContentData(0, filter, keyword);
            } else {
              fetchManageContentData(0, "", keyword);
            }
        }
        if (filter) {
          fetchManageContentData(0, filter, "");
        } else {
          fetchManageContentData(0, "", "");
        }
        setModalShow(false);
      } catch (error) {
        setToaster("Update Content", "Content update failed", "danger");
        set({ error: error.message, statusLoading: false });
      }
    },
    removeContent: async (id,setToaster, fetchManageContentData, filter, searchText) => {
      try {
        set({ deleteContLoading: true, error: null });
        const response = await deleteContent(id);
        setToaster("Delete Content", "Content Deleted successfully", "success");
        if (searchText) {
          const keyword = `&key=${searchText}&`;
          if (searchText && filter) {
            fetchManageContentData(0, filter, keyword);
          } else {
            fetchManageContentData(0, "", keyword);
          }
      }
      if (filter) {
        fetchManageContentData(0, filter, "");
      } else {
        fetchManageContentData(0, "", "");
      }
        set({deleteContLoading: false });
      } catch (error) {
        setToaster("Delete Content", "Deleting content failed", "danger");
        set({ error: error.message, deleteContLoading: false });
      }
    },
    postLinkTag: async (payload,setToaster, setModalShow) => {
      try {
        set({ deleteContLoading: true, error: null });
        const response = await postTag(payload);
        setToaster("Tag Link", "Tags Linked Successfully", "success");
        setModalShow(false);
      } catch (error) {
        setToaster("Tag Link", "Tag Linking Failed", "danger");
        set({ error: error.message, deleteContLoading: false });
      }
    },
    postManageContent: async ( payload,setToaster, fetchManageContentData, filter, searchText , setModalShow) => {
      try {
        set({ postLoading: true, error: null });
        const response = await addContent(payload);
        setToaster("Add Content", "Content saved successfully", "success");
        set({updateImageData:response.data, postLoading: false });
        if (searchText) {
            const keyword = `&key=${searchText}&`;
            if (searchText && filter) {
              fetchManageContentData(0, filter, keyword);
            } else {
              fetchManageContentData(0, "", keyword);
            }
        }
        if (filter) {
          fetchManageContentData(0, filter, "");
        } else {
          fetchManageContentData(0, "", "");
        }
        setModalShow(false);
      } catch (error) {
        setToaster("Add Content", "Content update failed", "danger");
        set({ error: error.message, postLoading: false });
      }
    },
  }));